export default {
    name: 'StepPrint',
    props: ['state'],
    data () {
        return {}
    },
    computed: {},
    methods: {
        /**
         * Try Go To Next Step
         *
         * Override this function to allow validation
         */
        tryGoToNextStep: function () {
            this.goToNextStep()
        },
        /**
         * Go To Next Step
         *
         * This sends an event to parent telling it to go to the next step
         */
        goToNextStep: function () {
            this.$emit('goToNextStep', 1)
        },
        /**
         * Close Search Result
         *
         * Triggers an event which our parent component can hook into
         */
        goToRoot: function () {
            this.$router.push({ name: 'root' })
        }
    }
}
